import React from 'react';
import './footer.css';
import MainFooter from './MainFooter';

const Footer = () => {
    return (
        <div className="footer">
            <MainFooter />
        </div>
    )
}
export default Footer ;